import type * as React from 'react';
import { del } from '@Domain/Api';
import aiProviderDeleted, {
	type AiProviderDeletedAction,
} from '@Application/Ai/AiConfiguration/Providers/Actions/aiProviderDeleted';
import aiProviderDeletionFailed, {
	type AiProviderDeletionFailedAction,
} from '@Application/Ai/AiConfiguration/Providers/Actions/aiProviderDeletionFailed';
import type DeleteAiProvider from '@Application/Ai/AiConfiguration/Providers/Commands/DeleteAiProvider';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../../parameters';

type Actions = AiProviderDeletedAction | AiProviderDeletionFailedAction;

export default (command: DeleteAiProvider) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			await del<void>(
				`${parameters.api.host}/api/accounts/${command.accountId}/ai-providers/${command.providerId}`,
			);

			const action = aiProviderDeleted({ providerId: command.providerId }, command.accountId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = aiProviderDeletionFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
